import service from '@/store/services/contratos-service';

const state = {
  list: {},
  contrato: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, contrato) => {
    state.contrato = contrato;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  contrato: state => state.contrato,
  dropdown: (state) => {
    return state.list.map(contrato => ({
      id: contrato.id,
      name: contrato.codigo,
      codigo: contrato.codigo,
      imovel_id: contrato.imovel?.id,
      inquilino_id: contrato.inquilino?.id,
      tipocontrato_id: contrato.tipocontrato?.id,
      situcontrato_id: contrato.situcontrato?.id,
      imoveltipo_id: contrato.imoveltipo?.id,
      datainicio: contrato.datainicio,
      valorlocacao: contrato.valorlocacao
    }));
  }
};

const contratos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default contratos;
